import React, { PropsWithChildren, RefObject, useMemo } from 'react';
import { useSelector } from 'react-redux';

import ChatContext from '@r1-frontend/entities/Chat';

import BP42CallbackPopup from '@r1-frontend/bp42';
import BP42Context from '@r1-frontend/bp42/BP42Context';
import { SurveyButton, SurveyContext, SurveyDialog } from '@r1-frontend/survey';

import { GlobalStyle } from '@r1-frontend/ui-react/components/GlobalStyles';
import UIKitGlobalStyle from '@r1-frontend/ui-kit/themes/UIKitGlobalStyle';

import CitySelectContainer from '~/src/components/CitySelectContainer';
import { Footer } from '~/src/components/Footer';
import { CDN_API_ENDPOINT } from '~/src/constants';
import Header from '~/src/features/_layout/Header';
import { getABNVariant } from '~/src/helpers/abn-tests';
import { selectCsrf } from '~/src/store/selectors/auth/selectCsrf';

import * as ST from './styled';

interface IApp {
    withMenu: boolean,
    withChat: boolean,
    withFooter: boolean,
    withBottomSticky?: RefObject<HTMLDivElement>,
    bgColor?: string,
    withEmailWidget?: boolean,
    emailWidgetText?: string,
}

const App = ({
    withMenu,
    withChat,
    withFooter,
    bgColor,
    withEmailWidget,
    withBottomSticky,
    emailWidgetText,
    children,
}: PropsWithChildren<IApp>) => {
    const csrf = useSelector(selectCsrf);

    const showFeedback = useMemo(() => getABNVariant('feedback') === 'show_feedback', []);

    return (
        <ST.AppContainer bgColor={bgColor} ref={withBottomSticky}>
            <SurveyContext>
                <BP42Context csrf={csrf}>
                    <ChatContext enable={withChat}>
                        <GlobalStyle endpoint={CDN_API_ENDPOINT}/>
                        <ST.GlobalStyle/>
                        <UIKitGlobalStyle endpoint={CDN_API_ENDPOINT}/>
                        {withMenu && <Header data-test='main-menu'/>}
                        <ST.Content>
                            {children}

                            {withFooter && <Footer
                                withEmailWidget={withEmailWidget}
                                emailWidgetText={emailWidgetText}
                                withChat={withChat}
                            />}
                        </ST.Content>
                        <CitySelectContainer/>
                        <BP42CallbackPopup/>
                        {showFeedback && (
                            <SurveyButton/>
                        )}
                        <SurveyDialog/>
                    </ChatContext>
                </BP42Context>
            </SurveyContext>
        </ST.AppContainer>
    );
};

export default App;
